import {
    Box,
    Button,
    CircularProgress,
    Grid,
    Select,
    Stack,
    TextField,
    Typography
  } from "@mui/material";
  import { GeoPoint, collection, getFirestore, query, where } from "firebase/firestore";
  import React, { useEffect } from "react";
  import AppBarHome from "../components/AppBar/Home";
  import LeafletMap from "../components/LeafletMap";
  import SpeciesSearch from "../components/SpeciesSearch";
  import { getAllData } from "../libs/firebase/firestore/getAllData";
  import { getQueryAllData } from "../libs/firebase/firestore/getQueryAllData";
  import { useNavigateToTop } from "../libs/useNavigateToTop";
import { uploadData } from "../libs/firebase/firestore/uploadData";
import { uploadDataWithName } from "../libs/firebase/firestore/uploadDataWithName";
import { camelCase } from "../utilities/camelCase";
import { updateData } from "../libs/firebase/firestore/updateData";
import AppBarReviewSystem from "../components/AppBar/ReviewSystem";
import { BonsaiSpeciesDatabase } from "../libs/bonsai/species";
  
  function ScreenReviewSystem({}) {
    const navigate = useNavigateToTop();
  
    // State for tasks data
    const [bonsaiGuides, setBonsaiGuides] = React.useState([]);
  
    const [species, setSpecies] = React.useState([]);

    //state for common name
    const [commonName, setCommonName] = React.useState("");
    //state for scientific name
    const [scientificName, setScientificName] = React.useState("");

  
    // loading state
    const [loading, setLoading] = React.useState(true);
  
    const handleBonsaiGuideClick = (guideId) => {
      navigate(`/bonsai-guide/${guideId}`);
    };
  
    
  
    useEffect(() => {
        const db = getFirestore();
        const q = query(collection(db, "bonsai-guides"),
        where("isNewSpecies", "==", true),
        );

        getQueryAllData(q, (bonsaiGuidesData) => {
            setBonsaiGuides(bonsaiGuidesData);
            setLoading(false);
        });
        getAllData("species", (speciesData) => {
            setSpecies(speciesData);
        });
    }, []);
  

    const handleSetBonsaiSpecies = (bonsaiGuideId, selectedSpecies) => {
        // ask if i want to update the species on the guide
       if( !window.confirm("Set species to " + selectedSpecies.commonName + " " + selectedSpecies.scientificName))return;

       
        if (!bonsaiGuideId) {
            alert("No bonsai guide id");
            return;
        }

        updateData(
            {
                commonName: selectedSpecies.commonName,
                scientificName: selectedSpecies.scientificName,
                isNewSpecies: false,
            },
            "bonsai-guides",
            bonsaiGuideId,
            () => {
                alert("Species set");
                // refresh the page
                window.location.reload();
            },
            (error) => {
                alert("Error: " + error);
            }
        )
        
    }

    const handleAddAllSpecies = ()=> {
      // go through each BonsaiSpeciesDatabase and add to firebase database

      //get keys of BonsaiSpeciesDatabase
      const keys = Object.keys(BonsaiSpeciesDatabase);

      keys.forEach((specieName) => {
        const species = BonsaiSpeciesDatabase[specieName];
        const scientificName = species["Botanical name"];
        const commonName = species["Common name"];

        const docName = camelCase(scientificName);
        uploadDataWithName({
          commonName: commonName,
          scientificName: scientificName,
      }, "species", docName, ()=>{
          console.log("Species added", docName);
      },
      (error) => {
          alert("Error: " + error);
      });


      });
    }
  
    return (
      <Box>
        <AppBarReviewSystem />
        <Box
          sx={{
            padding: "1rem",
            margin: "auto",
            // maxWidth: "1200px",
          
          }}
        >
        <Box
          style={{
            margin: "auto 0",
          }}
        > 
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
  
        {/* Title and description */}
          <Typography variant="h4">Bonsai Guides</Typography>
          <Typography gutterBottom
            sx={{
              marginBottom: "1rem",
            }}
          >
            Below are guides waiting for their species to be confirmed / added to the database.
          </Typography>
  
        {/* SHows each bonsai guide as a card */}
          <Stack
            direction="row"
            spacing={2}
            style={{
              flexWrap: "wrap",
              overflowY:"auto"
            }}
          >
            
  
          {loading && (
            <Box
              style={{
                textAlign: "center",
                margin: "2rem 0rem",
              }}
            >
              <CircularProgress />
            </Box>
          )}
            {bonsaiGuides.map((bonsaiGuide) => {
              return (
                <Box
                  key={bonsaiGuide.storageDocumentId}
                  style={{
                    padding: "1rem",
                    margin: "1rem",
                    marginLeft:"0rem",
                    width: "100%",
                    border: "2px solid black",
                    boxShadow: "4px 4px 0px 0px rgb(109 112 108)",
                    borderRadius: ".3rem .3rem .3rem .3rem",
                    position: "relative",
                    zIndex: 1,
                  }}
                //   onClick={()=> {
                //     handleBonsaiGuideClick(bonsaiGuide.storageDocumentId);
                //   }}
                >
                  <Grid container>
                    <Grid item xs={12}
                    >                      
                    <Typography> Scientific: {bonsaiGuide.scientificName}</Typography>
                    <Typography> Common: {bonsaiGuide.commonName}</Typography>
                      </Grid>
                    
                    <Grid item xs={6}>
                    <Typography>Created: {(bonsaiGuide.timeDateCreated)? bonsaiGuide.timeDateCreated.toDate().toLocaleDateString(): null}</Typography>
                      
                      </Grid>
                    <Grid item xs={12}
                        style={{
                            marginTop: "1rem",
                        }}
                    >
                        <SpeciesSearch
                            species={species}
                            canAdd={false}
                            onSelect={(species, isNew =false) => {
                                if (species === null) {
                                    return;
                                }
                                handleSetBonsaiSpecies(bonsaiGuide.storageDocumentId, species);
                            }}
                        />
                      </Grid>
                    </Grid>
                </Box>
              );
            })}
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h4">Add species</Typography>
            <Typography>
              Type in the name of the species to add
            </Typography>
            {/* Add Species Item */}
            {/* Common Name textfield */}
            <TextField
                label="Common Name"
                variant="outlined"
                fullWidth
                margin="normal"
                value={commonName}
                onChange={(e) => setCommonName(e.target.value)}
            />
            {/* Scientific Name textfield */}
            <TextField
                label="Scientific Name"
                variant="outlined"
                fullWidth
                margin="normal"
                value={scientificName}
                onChange={(e) => setScientificName(e.target.value)}
                
            />
            <Button
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                disabled={
                    commonName === "" ||
                    scientificName === ""
                }
                sx={{
                    marginTop: "1rem",
                }}
                onClick={() => {
                    // doc name is scientific name 
                    // capitalize first letter after a space
                    let docName = camelCase(scientificName);
                    // remove spaces
                    docName = docName.replace(/ /g, "");

                    // console.log(docName);
                    // return;

                    // add species
                    uploadDataWithName({
                        commonName: commonName,
                        scientificName: scientificName,
                    }, "species", docName, ()=>{
                        console.log("Species added");
                        // clear textfields
                        setCommonName("");
                        setScientificName("");
                    },
                    (error) => {
                        alert("Error: " + error);
                    });
                }}
            >
                Add Species
            </Button>
            

  
        
          </Grid>
          </Grid>
  
          
        </Box>
        {/* <Button
          onClick={handleAddAllSpecies}
        >
          Add all species to database
        </Button> */}
        
        </Box>
      </Box>
    );

  }

  
  export default ScreenReviewSystem;
  